import React from 'react';

export default function() {
  return (
    <svg width="126px" height="126px" viewBox="0 0 126 126" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-658.000000, -252.000000)">
          <g transform="translate(540.000000, 234.000000)">
            <g transform="translate(96.000000, 0.000000)">
              <g transform="translate(22.000000, 18.000000)">
                <circle fill="#FFFFFF" cx="63" cy="63" r="63" />
                <g transform="translate(20.000000, 30.000000)">
                  <path d="M20,36 L86,36 L86,92 C86,94.209139 84.209139,96 82,96 L20,96 L20,36 Z" fill="#DAEFFE" />
                  <path
                    d="M58,63.166 C58,64.822 57.622,66 56,66 L50,66 C48.39,66 48,64.9 48,63.166 L48,62 L58,62 L58,63.166 Z M58,60 L56,60 L56,46 L54,46 L54,60 L52,60 L52,46 L50,46 L50,60 L48,60 L48,46 L46,46 L46,63.166 C46,65.994 47.302,68 50,68 L52,68 L52,86 L54,86 L54,68 L55.626,68 C58.466,68 60,65.822 60,63.166 L60,46 L58,46 L58,60 Z"
                    fill="#4EB7F5"
                  />
                  <path
                    d="M13,0 L71,0 C73.209139,-4.05812251e-16 75,1.790861 75,4 L75,18 L9,18 L9,4 C9,1.790861 10.790861,4.05812251e-16 13,0 Z M36,6 C34.3431458,6 33,7.34314575 33,9 C33,10.6568542 34.3431458,12 36,12 L48,12 C49.6568542,12 51,10.6568542 51,9 C51,7.34314575 49.6568542,6 48,6 L36,6 Z"
                    fill="#C1E4FE"
                  />
                  <path d="M0,36 L20,36 L20,96 L4,96 C1.790861,96 2.705415e-16,94.209139 0,92 L0,36 Z" fill="#C1E4FE" />
                  <polygon fill="#EAF7FF" points="10 18 75 18 86 36 20 36" />
                  <polygon fill="#C1E4FE" points="10 18 20 36 1.69248296e-12 36" />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
